import { Flex, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { IconBlock } from '../../../../../icons/IconBlock'
import {
  DismissButton,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  UseDrawerStateReturn,
} from '../../../../Drawer'
import { messages } from './messages'
import styles from './noPermission.css'

type Props = {
  drawerState: UseDrawerStateReturn
  description: {
    id: string
  }
  title: {
    id: string
  }
}

export function NoPermissionView(props: Props) {
  const { drawerState, description, title } = props

  const { $t } = useIntl()

  return (
    <Drawer state={drawerState}>
      <DrawerHeader>
        <DrawerTitle>{$t(title)}</DrawerTitle>
        <DismissButton onHide={drawerState.hide} />
      </DrawerHeader>
      <DrawerContent>
        <Flex
          className={styles.noPermissionContainer}
          justify="center"
          align="center"
          direction="column"
        >
          <IconBlock />
          <Text variant="pageTitle">{$t(messages.title)}</Text>
          <Text variant="title2" tone="secondary">
            {$t(description, {
              b: (content) => {
                return (
                  <Text variant="title1" tone="secondary">
                    {content}
                  </Text>
                )
              },
            })}
          </Text>
        </Flex>
      </DrawerContent>
    </Drawer>
  )
}
